import React, { useEffect, useState } from "react";
import { api, formatErr, fmtINR } from "@/lib/api";
import { toast } from "sonner";
import { Plus, Trash } from "@phosphor-icons/react";

export default function Products() {
  const [rows, setRows] = useState([]);
  const [show, setShow] = useState(false);
  const [form, setForm] = useState({ name: "", hsn: "", sac: "", kind: "goods", unit: "NOS", price: 0, tax_rate: 18 });

  const load = async () => setRows((await api.get("/products")).data);
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/products", { ...form, price: Number(form.price), tax_rate: Number(form.tax_rate) });
      toast.success("Product added");
      setShow(false);
      setForm({ name: "", hsn: "", sac: "", kind: "goods", unit: "NOS", price: 0, tax_rate: 18 });
      load();
    } catch (err) { toast.error(formatErr(err.response?.data?.detail)); }
  };
  const del = async (id) => {
    if (!confirm("Delete?")) return;
    await api.delete(`/products/${id}`);
    load();
  };

  return (
    <div className="space-y-5 lb-fade" data-testid="products-page">
      <div className="flex items-end justify-between">
        <div>
          <div className="text-[11px] uppercase tracking-widest text-neutral-500 font-semibold">Master</div>
          <h1 className="font-display font-extrabold text-3xl tracking-tight">Products / Items</h1>
        </div>
        <button className="lb-btn" onClick={() => setShow((s) => !s)} data-testid="add-product-btn">
          <Plus size={14} /> New Product
        </button>
      </div>

      {show && (
        <form onSubmit={submit} className="lb-card p-6 grid grid-cols-6 gap-4">
          <div className="col-span-2">
            <label className="lb-label">Name</label>
            <input required className="lb-input" value={form.name}
                   onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="pf-name" />
          </div>
          <div>
            <label className="lb-label">Kind</label>
            <select className="lb-select" value={form.kind} data-testid="pf-kind"
                    onChange={(e) => setForm({ ...form, kind: e.target.value })}>
              <option value="goods">Goods</option>
              <option value="service">Service</option>
            </select>
          </div>
          <div>
            <label className="lb-label">{form.kind === "service" ? "SAC" : "HSN"}</label>
            <input className="lb-input font-mono"
                   value={form.kind === "service" ? form.sac : form.hsn}
                   onChange={(e) => setForm(form.kind === "service"
                     ? { ...form, sac: e.target.value } : { ...form, hsn: e.target.value })}
                   data-testid="pf-hsn-sac" />
          </div>
          <div>
            <label className="lb-label">Unit</label>
            <input className="lb-input" value={form.unit} onChange={(e) => setForm({ ...form, unit: e.target.value })} />
          </div>
          <div>
            <label className="lb-label">Price</label>
            <input type="number" step="0.01" required className="lb-input font-mono text-right"
                   value={form.price} onChange={(e) => setForm({ ...form, price: e.target.value })} data-testid="pf-price" />
          </div>
          <div className="col-span-2">
            <label className="lb-label">GST %</label>
            <input type="number" step="0.01" className="lb-input font-mono text-right"
                   value={form.tax_rate} onChange={(e) => setForm({ ...form, tax_rate: e.target.value })} data-testid="pf-tax" />
          </div>
          <div className="col-span-6 flex gap-2">
            <button className="lb-btn" data-testid="pf-submit">Save</button>
            <button type="button" className="lb-btn lb-btn-ghost" onClick={() => setShow(false)}>Cancel</button>
          </div>
        </form>
      )}

      <div className="lb-card">
        <table className="lb-table">
          <thead>
            <tr><th>Name</th><th>Kind</th><th>HSN/SAC</th><th>Unit</th><th className="text-right">Price</th><th className="text-right">GST %</th><th></th></tr>
          </thead>
          <tbody>
            {rows.map((p) => (
              <tr key={p.id}>
                <td className="font-semibold">{p.name}</td>
                <td><span className="lb-badge">{p.kind || "goods"}</span></td>
                <td className="font-mono text-xs">{p.kind === "service" ? p.sac : p.hsn}</td>
                <td>{p.unit}</td>
                <td className="amt">{fmtINR(p.price)}</td>
                <td className="num">{p.tax_rate}%</td>
                <td><button onClick={() => del(p.id)} className="text-neutral-500 hover:text-rose-600"><Trash size={14} /></button></td>
              </tr>
            ))}
            {!rows.length && <tr><td colSpan={7} className="text-center py-10 text-neutral-500">No products</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
